"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationServiceImpl = void 0;
var RegistrationProviderImpl_1 = require("./provider/airabbi/RegistrationProviderImpl");
var RegistrationServiceImpl = (function () {
    function RegistrationServiceImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.sendSmsByFormId = function (formId, content) {
            return _this.provider.sendSmsByFormId(formId, content);
        };
        this.getAllClasses = function () {
            return _this.provider.getAllClasses();
        };
        this.getAllGoods = function () {
            return _this.provider.getAllGoods();
        };
        this.getAllInformationSources = function () {
            return _this.provider.getAllInformationSources();
        };
        this.getOldStudentData = function (phoneNum) {
            return _this.provider.getOldStudentData(phoneNum);
        };
        this.syncGoogleForm = function (id) {
            return _this.provider.syncGoogleForm(id);
        };
        this.getAllSyncResults = function () {
            return _this.provider.getAllSyncResults();
        };
        this.provider = new RegistrationProviderImpl_1.RegistrationProviderImpl(cfg);
    }
    RegistrationServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return this.provider.init(env);
    };
    RegistrationServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
        this.provider.setDebuggable(this.cfg.debuggable);
    };
    RegistrationServiceImpl.prototype.stopAllMonitor = function () {
        return this.provider.stopAllMonitor();
    };
    RegistrationServiceImpl.prototype.createRegistrationForm = function (form) {
        return this.provider.createRegistrationForm(form);
    };
    RegistrationServiceImpl.prototype.getRegistrationForm = function (id) {
        return this.provider.getRegistrationForm(id);
    };
    RegistrationServiceImpl.prototype.getRegistrationForms = function () {
        return this.provider.getRegistrationForms();
    };
    RegistrationServiceImpl.prototype.removeRegistrationForm = function (form) {
        return this.provider.removeRegistrationForm(form);
    };
    RegistrationServiceImpl.prototype.updateRegistrationForm = function (form) {
        return this.provider.updateRegistrationForm(form);
    };
    RegistrationServiceImpl.prototype.createSignUpUser = function (registration) {
        return this.provider.createSignUpUser(registration);
    };
    RegistrationServiceImpl.prototype.updateSignUpUser = function (signUpUser) {
        return this.provider.updateSignUpUser(signUpUser);
    };
    RegistrationServiceImpl.prototype.upsertDiscountCoupon = function (classIds, code, startTime, endTime, maxCount, remark, target, ccEmailList, expirCcEmailList, payAmount, formIds) {
        return this.provider.upsertDiscountCoupon(classIds, code, startTime, endTime, maxCount, remark, target, ccEmailList, expirCcEmailList, payAmount, formIds);
    };
    RegistrationServiceImpl.prototype.getDiscountCoupons = function () {
        return this.provider.getDiscountCoupons();
    };
    RegistrationServiceImpl.prototype.checkCoupon = function (couponType, classId, code, generalFormId) {
        return this.provider.checkCoupon(couponType, classId, code, generalFormId);
    };
    RegistrationServiceImpl.prototype.getGroupCodeUsages = function () {
        return this.provider.getGroupCodeUsages();
    };
    RegistrationServiceImpl.prototype.getSignUpUsers = function (filter, sort) {
        return this.provider.getSignUpUsers(filter, sort);
    };
    RegistrationServiceImpl.prototype.getRegisUserNum = function (classIds) {
        return this.provider.getRegisUserNum(classIds);
    };
    return RegistrationServiceImpl;
}());
exports.RegistrationServiceImpl = RegistrationServiceImpl;
//# sourceMappingURL=RegistrationServiceImpl.js.map